<template lang="pug">
  div.summary-bar.bg-dark
    div.bottom-border
      strong.no-wrap Zusammenfassung
        span(v-if="!loading && orderSummary") &nbsp;-&nbsp;Menge:&nbsp;{{ orderSummary.totalQuantity }}
    div.d-flex.align-items-end.justify-content-between
      div.summary-content.flex-grow-1
        div(v-if="loading") Bitte warten...
        div(v-else-if="hasError") Bitte korrigieren Sie die Bestellung
        div(v-else-if="!loading && orderSummary")
          span.no-wrap(v-if="customer && customer.studentProducts === 1")
            strong.no-wrap {{ orderSummary.totalPriceB2c }}
          span.no-wrap(v-else)
            strong.no-wrap {{ orderSummary.totalPriceB2b }}
          br
          span.no-wrap
            strong.no-wrap {{ orderSummary.onlineDiscount }} {{ discountLabel }}
          br
          span.no-wrap
            strong.no-wrap {{ orderSummary.shippingCosts }} Versand
          br
          span.no-wrap
            strong.no-wrap {{ orderSummary.vat }} {{ orderSummary.vatPercentage }}
          br
          span.no-wrap
            strong.no-wrap {{ orderSummary.totalPrice }} Gesamt
        div(v-else)
          span 0.00
      div.d-flex.flex-column.align-items-end.flex-shrink-0
        button.btn.btn-primary.btn-md.ml-2(
          @click="showOrderSummary"
          v-if="!loading"
          :disabled="loading || !orderSummary || hasError || !hasOrderableItems"
          type="button"
          ) BESTELLEN
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    hasError: {
      type: Boolean,
      required: true,
      default: false
    },
    loading: {
      type: Boolean,
      required: true,
      default: false
    },
    orderSummary: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  computed: {
    ...mapGetters('authentication', ['customer']),
    discountLabel () {
      // Check if customer is a student
      if (this.customer && this.customer.studentProducts === 1) {
        return 'Schüler-Rabatt 10%'
      }
      return 'Online-Rabatt 3%'
    },
    hasOrderableItems () {
      // The backend computes totalQuantity over orderable items only, so
      // a zero here means the cart is either empty or contains only OOS lines.
      return this.orderSummary && this.orderSummary.totalQuantity > 0
    }
  },
  methods: {
    showOrderSummary () {
      this.$emit('show-order-summary')
    }
  }
}
</script>
<style lang="stylus">
  .summary-bar
    position fixed
    bottom 0px
    // background rgba(0, 0, 0, 0.85)
    width 400px
    right 0
    color white
    z-index 998
    transition all 0.25s
    padding 16px

    .bottom-border
      border-bottom 1px solid rgba(255, 255, 255, 0.5)
      margin-bottom 4px

  @media all and (max-width: 768px)
    .summary-bar
      width 100%
      border-top 1px solid white

</style>
